import { styled } from "@material-ui/core";
import {
    asDateTime, Column, Flex,
    FormLabel, Input
} from "lqx-react/lib";
import * as React from "react";
import { AssetTypesDisplay } from "../../api/assetType";

export const ConnectionsImportDetails = (importTemplate) => {
    return importTemplate.importDetails ? (
        <>
            <Flex row>
                <Column>
                    <StyledFormLabel>Data Format</StyledFormLabel>
                    <StyledInput value={importTemplate.importDetails.dataFormat} disabled />
                </Column>
                <Column>
                    <StyledFormLabel>Asset Type</StyledFormLabel>
                    <StyledInput value={AssetTypesDisplay[importTemplate.importDetails.assetTypeId]} disabled />
                </Column>
                <Column>
                    <StyledFormLabel>Created On</StyledFormLabel>
                    <StyledInput value={asDateTime(importTemplate.importDetails.createdOn)} disabled />
                </Column>
            </Flex>
        </>) : <></>;
}

const StyledFormLabel = styled(FormLabel)({
    alignSelf: 'start',
    paddingLeft: 4
})

const StyledInput = styled(Input)({
    marginTop: 4,
    marginBottom: 4,
    height: 32
})